import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/services/authentication/token-interceptor';
import { SubscriptionLockInterceptor } from './shared/services/authentication/subscription-lock-interceptor';
import { ProfileRefreshInterceptor } from './shared/services/authentication/profile-refresh-interceptor';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOtpInputModule } from 'ng-otp-input';
import { registerLocaleData } from '@angular/common';
import localeArSA from '@angular/common/locales/ar-SA';
import extraArSA from '@angular/common/locales/extra/ar-SA';
import { AppConfigService } from './shared/services/http-services/app-config.service';
import { BillingReturnComponent } from './shared/pages/billing-return/billing-return.component';

export function initAppConfig(appConfig: AppConfigService) {
  return () => appConfig.load().toPromise();
}

registerLocaleData(localeArSA, 'ar-SA', extraArSA);

@NgModule({
  declarations: [
    AppComponent,
    BillingReturnComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgSelectModule,
    NgOtpInputModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      closeButton: true,
      iconClasses: {
        error: '',
        success: '',
        info: '',
        warning: ''
      }
    })
  ],
  providers: [
    FormBuilder,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubscriptionLockInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProfileRefreshInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'ar-SA' },
    {
      provide: APP_INITIALIZER,
      useFactory: initAppConfig,
      deps: [AppConfigService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
